import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Container from "@mui/material/Container";
import { useMediaQuery, useTheme } from "@mui/material";
import StickyHeader from "./StickyHeader";
import CustomizedButton from "./CustomizedButton";

import config from "../config";

export default function StickyHeadTable() {
    const memberID = window.sessionStorage.getItem("id");
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const columns = [
        { id: "board_num", label: "No.", minWidth: 10 },
        { id: "member_id", label: "Author", minWidth: 10 },
        {
            id: "board_title",
            label: "Title",
            minWidth: 350,
            format: (value, row) => (row.board_reply ? `${value} (Replied)` : value),
        },
        { id: "board_date", label: "Date", minWidth: 40 },
    ];

    let paddingTop = "200px";
    if (isSmallScreen) {
        paddingTop = "140px";
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const navigate = useNavigate();
    const handleClick = () => {
        navigate("/boardInsert");
    };

    const [boardlist, setBoardList] = useState([]);

    const getList = () => {
        axios
            .get(`${config.API_URL}/customer/get`, {})
            .then((res) => {
                const { data } = res;
                setBoardList(data);
            })
            .catch((e) => {
                console.error(e);
            });
    };

    const handleTableCellClick = (event, post) => {
        navigate(`/board/${post.board_num}`);
    };

    useEffect(() => {
        getList();
    }, []);
    return (
        <div>
            <StickyHeader kind="Customer Center" />
            <Container sx={{ paddingTop: { paddingTop } }}>
                <h2 style={{ display: "flex", alignItems: "center", color: "black" }}>
                    <span style={{ marginRight: "auto" }}>Contact Center</span>
                    {memberID && <CustomizedButton onClick={handleClick} label="Write Post"></CustomizedButton>}
                </h2>

                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                    <TableContainer sx={{ maxHeight: 640 }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {columns.map((column) => (
                                        <TableCell
                                            key={column.board_num}
                                            align={column.align || "center"}
                                            style={{ minWidth: column.minWidth }}
                                        >
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {boardlist
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((post, index) => {
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={index}
                                                sx={{
                                                    "&:hover": {
                                                        cursor: "pointer",
                                                        backgroundColor: "#dddddd",
                                                    },
                                                }}
                                                onClick={(event) => handleTableCellClick(event, post)}
                                            >
                                                {columns.map((column) => {
                                                    return (
                                                        <TableCell key={column.id} align="center">
                                                            {column.id === "board_num"
                                                                ? boardlist.length - (page * rowsPerPage + index)
                                                                : column.format
                                                                  ? column.format(post[column.id], post)
                                                                  : post[column.id]}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        component="div"
                        count={boardlist.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            </Container>
        </div>
    );
}
